// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v7Gx9QreypiHOe {
  box-sizing: border-box;
  scrollbar-gutter: stable both-edges;
  background: #000000bf;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  display: flex;
  position: fixed;
  overflow: auto;
}

@supports (height: 100dvh) {
  .v7Gx9QreypiHOe {
    width: 100dvw;
    height: 100dvh;
  }
}

@media print {
  .v7Gx9QreypiHOe {
    width: auto !important;
    height: auto !important;
    max-height: 100% !important;
    display: block !important;
    position: relative !important;
    overflow: scroll !important;
  }
}

.wdnu883nxUAuaU {
  width: auto;
  margin: var(--ds-space-600, 48px) var(--ds-space-0, 0);
  background: none;
  position: relative;
}

.wdnu883nxUAuaU:focus {
  outline: none;
}

@media print {
  .wdnu883nxUAuaU {
    width: 100%;
    margin: var(--ds-space-0, 0);
  }
}

.sL1qTnMj1NtV5n {
  align-items: flex-start;
}

.MH52LcMfuPZMIK {
  align-items: center;
}

.u5tb98MKhivT7x {
  align-items: flex-end;
}

.A1sA8XbdgXQEUS {
  background: var(--ds-blanket, #091e427d);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}

@media only screen and (width <= 750px) {
  .wdnu883nxUAuaU {
    width: 100%;
  }
}

@media only screen and (width <= 600px), only screen and (width <= 450px) {
  .wdnu883nxUAuaU {
    width: 100%;
    margin: var(--ds-space-0, 0);
  }
}
`, ""]);
// Exports
export var overlay = `v7Gx9QreypiHOe`;
export var contents = `wdnu883nxUAuaU`;
export var alignTop = `sL1qTnMj1NtV5n`;
export var alignCenter = `MH52LcMfuPZMIK`;
export var alignBottom = `u5tb98MKhivT7x`;
export var effectBlur = `A1sA8XbdgXQEUS`;
export default ___CSS_LOADER_EXPORT___;
